import { RouteConfig } from 'vue-router/types/router';
import MswIssueList from './msw-issue-list.vue';

export const issuelist: RouteConfig = {
  path: 'issuelist',
  component: MswIssueList,
};
